import React from 'react';
import { useTypedDispatch, useTypedSelector } from 'src/redux/utils';
import { autoAuthenticateUser, logout, refreshWallet } from '@profile/src/redux/remoteActions';
import { TooltipProvider } from 'src/Components/TooltipProvider';
import { menuList, moreList } from './config';
import { logConnectWalletEvent } from 'src/utils/analytic';
import { addChainChangedListener, addAccountChangedListener } from 'src/utils/ethereum';
import { makeSelectCurrentAvatar, makeSelectCurrentAvatarFrame } from './selectors';
import BreakpointContent from '../BreakpointContent';
import HeaderMobile from './Components/HeaderMobile';
import HeaderDesktop from './Components/HeaderDesktop';
import { useHistory } from 'react-router';
import { RouteName } from 'src/routes/config';
import { getPreferredWalletProviderName } from 'src/utils/session';
import { putWalletConnect } from 'src/redux/api';
import noop from 'lodash/noop';
import { TestableProvider } from '@wolffun/testable-id';
import { fetchThetanWorldConfig } from '@main/src/redux/actions';

const Header = () => {
  const dispatch = useTypedDispatch();
  const selectCurrentAvatar = React.useRef(makeSelectCurrentAvatar());
  const avatar = useTypedSelector(selectCurrentAvatar.current);
  const selectCurrentAvatarFrame = React.useRef(makeSelectCurrentAvatarFrame());
  const avatarFrame = useTypedSelector(selectCurrentAvatarFrame.current);
  const refreshToken = useTypedSelector(state => state.refreshToken);
  const history = useHistory();
  React.useEffect(() => {
    const dispatchAuthenUser = async () => {
      const {
        data
      } = await dispatch(autoAuthenticateUser());
      const provider = await getPreferredWalletProviderName();

      if (data) {
        logConnectWalletEvent({
          THC: data.thcBalance,
          THG: data.thgBalance,
          userId: data.user.id,
          email: data.user.email,
          walletAddress: data.accounts[0],
          provider: provider || ''
        });
        putWalletConnect({
          walletType: provider ?? 'Unknown'
        }).catch(noop); // avoid logging error
      }
    };

    dispatchAuthenUser();
  }, []);
  React.useEffect(() => {
    const removeChainChanged = addChainChangedListener(() => {
      dispatch(refreshWallet());
    });
    const removeAccountChanged = addAccountChangedListener(() => {
      dispatch(refreshWallet());
    });
    return () => {
      removeChainChanged();
      removeAccountChanged();
    };
  }, [dispatch]);
  React.useEffect(() => {
    if (refreshToken.isForceLogout) {
      dispatch(logout());
      history.push({
        pathname: RouteName.Login,
        state: {
          redirectTo: refreshToken.pathname
        }
      });
    }
  }, [refreshToken.isForceLogout, refreshToken.pathname]);
  React.useLayoutEffect(() => {
    dispatch(fetchThetanWorldConfig());
  }, [dispatch]);
  return /*#__PURE__*/React.createElement(TestableProvider, {
    testId: "header"
  }, /*#__PURE__*/React.createElement(TooltipProvider, null, /*#__PURE__*/React.createElement(BreakpointContent, {
    renderPhone: () => /*#__PURE__*/React.createElement(HeaderMobile, {
      menuList: menuList,
      moreList: moreList,
      avatar: avatar,
      avatarFrame: avatarFrame
    }),
    renderTablet: () => /*#__PURE__*/React.createElement(HeaderMobile, {
      menuList: menuList,
      moreList: moreList,
      avatar: avatar,
      avatarFrame: avatarFrame
    }),
    renderDesktop: () => /*#__PURE__*/React.createElement(HeaderDesktop, {
      avatar: avatar,
      avatarFrame: avatarFrame
    })
  })));
};

export default Header;